import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { useEffect } from 'react'
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet'
import { GeoPoint } from 'types/osmAddress'

const markerIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
})

const DEFAULT_CENTER: GeoPoint = { lat: 46.8139, lng: -71.208 }
const DEFAULT_ZOOM = 5
const SELECTED_ZOOM = 16

interface MapViewUpdaterProps {
  center: GeoPoint
  zoom: number
}

function MapViewUpdater({ center, zoom }: MapViewUpdaterProps) {
  const map = useMap()

  useEffect(() => {
    map.setView([center.lat, center.lng], zoom, { animate: true })
  }, [map, center.lat, center.lng, zoom])

  return null
}

interface OsmMapPreviewProps {
  location?: GeoPoint | null
  className?: string
  height?: string
}

const OsmMapPreview = ({
  location,
  className = '',
  height = '220px',
}: OsmMapPreviewProps) => {
  const hasLocation =
    location != null &&
    Number.isFinite(location.lat) &&
    Number.isFinite(location.lng)

  const center = hasLocation ? location! : DEFAULT_CENTER
  const zoom = hasLocation ? SELECTED_ZOOM : DEFAULT_ZOOM

  return (
    <div
      className={`relative z-0 isolate overflow-hidden rounded-xl border border-gray-200 ${className}`}
      style={{ height }}
    >
      <MapContainer
        center={[center.lat, center.lng]}
        zoom={zoom}
        scrollWheelZoom={false}
        className="h-full w-full"
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapViewUpdater center={center} zoom={zoom} />
        {hasLocation ? (
          <Marker position={[location!.lat, location!.lng]} icon={markerIcon} />
        ) : null}
      </MapContainer>
    </div>
  )
}

export default OsmMapPreview
